import React, { useEffect, useRef, useState } from "react";
import { UserOutlined } from "@ant-design/icons";
import { Form, Button, Input } from "antd";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import {
  getAllowedDomains,
  getLoginRequest,
  initMsalOnce,
} from "../../api/config";
import { useHistory } from "react-router-dom";

import UserIcon from "@src/styles/image/logo.png";
import "./login.scss";
import { lang, COMMON_CONSTANT } from "../../constants/common.const";

function Login() {
  const [disableButton, setDisableButton] = useState(false);
  const { instance, accounts, inProgress } = useMsal();
  const history = useHistory();
  const didRedirect = useRef(false);

  useEffect(() => {
    if (
      !didRedirect.current &&
      inProgress === InteractionStatus.None &&
      accounts &&
      accounts.length > 0
    ) {
      const active = instance.getActiveAccount();
      if (!active) {
        instance.setActiveAccount(accounts[0]);
      }

      didRedirect.current = true;
      history.replace("/");
    }
  }, [accounts, inProgress, history, instance]);

  const onFinish = async ({ email : finalEmail }) => {
    const email = String(finalEmail).trim()
    if (inProgress !== InteractionStatus.None) return;

    sessionStorage.clear();
    setDisableButton(true);

    try {
      const msalConfig = initMsalOnce(email);

      const loginRequest = {
        ...getLoginRequest(),
        loginHint: email,
        prompt: "login"
      };

      await msalConfig.loginRedirect(loginRequest);
    } catch (e) {
      console.error("Login error", e);
      setDisableButton(false);
    }
  };

  if (
    inProgress !== InteractionStatus.None ||
    (accounts && accounts.length > 0)
  ) {
    return null;
  }

  const validateEmailDomain = (_, value) => {
    const email = (value || "").trim();

    if (!email) {
      return Promise.reject(new Error("メールアドレスを入力してください。"));
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return Promise.reject(new Error("メールアドレスが不正です。"));
    }

    const allowedDomains = getAllowedDomains();
    const isAllowedDomain = allowedDomains.some((domain) =>
      email.toLowerCase().endsWith(`@${domain.toLowerCase()}`)
    );

    if (!isAllowedDomain) {
      return Promise.reject(new Error("メールアドレスが不正です。"));
    }

    return Promise.resolve();
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-bg" />
      </div>
      <div className="login-right">
        <div className="login-form-container">
          <img
            src={UserIcon}
            alt="Logo"
            style={{ maxWidth: "100%", marginBottom: 20 }}
          />
          <div className="login-form-title">{lang.NAME_SYSTEM}</div>
          <Form name="login" layout="vertical" onFinish={onFinish}>
            <Form.Item
              name="email"
              validateTrigger="onBlur"
              rules={[
                {
                  validator: validateEmailDomain,
                },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder={lang.MAIL_ADDRESS}
                autoComplete="email"
              />
            </Form.Item>
            <div className="login-btn-container">
              <Button
                className="login-btn"
                type="primary"
                htmlType="submit"
                disabled={disableButton}
              >
                {lang.SIGN_IN}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default Login;
